export default {
    deliveredImages: { list: [] }
};
